import { create } from "zustand"

interface DataStore {
  isViewInterestSelectModalIndex: number
  interestTreatment: string[]
  interestProcedure: string[]
  setIsViewInterestSelectModalIndex: (index: number) => void
  setInterestTreatment: (treatment: string) => void
  setInterestProcedure: (procedure: string) => void
}

const useDataStore = create<DataStore>((set) => ({
  isViewInterestSelectModalIndex: 0,
  interestTreatment: [],
  interestProcedure: [],
  setIsViewInterestSelectModalIndex: (index: number) => set({ isViewInterestSelectModalIndex: index }),
  setInterestTreatment: (interestTreatment: string) =>
    set((state) => {
      if (state.interestTreatment.includes(interestTreatment)) {
        return {
          interestTreatment: state.interestTreatment.filter((treatment: string) => treatment !== interestTreatment) as string[],
        }
      } else {
        return { interestTreatment: [...state.interestTreatment, interestTreatment] as string[] }
      }
    }),
  setInterestProcedure: (procedure: string) =>
    set((state) => {
      if (state.interestProcedure.includes(procedure)) {
        return {
          interestProcedure: state.interestProcedure.filter((item: string) => item !== procedure) as string[],
        }
      } else {
        return { interestProcedure: [...state.interestProcedure, procedure] as string[] }
      }
    }),
}))

export default useDataStore
